export const CREATED_AT_SLUG = 'created_at'
export const NEWS_CARD_SLUG = 'news-card'
